import type { ButtonProps } from '@chakra-ui/react'
import React from 'react'

import { useRippleEffectClick } from './hooks/use-ripple-effect-click'
import { RippleButtonStyles } from './ripple-button.styles'

export type RippleButtonProps = ButtonProps & {
    rippleColor?: string
}

/**
 * A 3p branded theme Button with the material ui ripple effect. The effect is not possible in css only, hence
 * this component extends the core Chakra button for the effect.
 *
 * @see 3p Figma design https://www.figma.com/file/AVVZO09XE8fZ0uuOaJYcQg/B2C-Onboarding---for-Dev?node-id=2759%3A24812
 * @see ripple effect mui https://mui.com/components/buttons/#main-content
 */
export const RippleButton = (props: RippleButtonProps) => {
  const ref = useRippleEffectClick()

  return (
    <RippleButtonStyles
      {...props}
      ref={ref}
    />
  )
}
